import React from 'react';

import { bind } from 'bind-decorator';

import { Menu } from '@material-ui/core';

import IconButton from './icon-button';

export type TContentRender = (
  closeWrapper: (
    callback?: (e: React.MouseEvent<HTMLElement>) => any
  ) => (e: React.MouseEvent<HTMLElement>) => any,
  handleClose: () => any
) => React.ReactNode | React.ReactNode[];

export interface IProps {
  children: TContentRender;

  className?: string;
  element?: React.ReactElement;
  iconButtonElement?: React.ReactNode;
}

export interface IState {
  anchorEl: HTMLElement | null;
}

class IconMenu extends React.Component<IProps, IState> {
  state = {
    anchorEl: null
  };

  @bind
  handleClick(event: React.MouseEvent<HTMLElement>) {
    this.setState({ anchorEl: event.currentTarget });
  }

  @bind
  generateCloseWrapper(
    callback?: (e: React.MouseEvent<HTMLElement>) => any
  ): (e: React.MouseEvent<HTMLElement>) => any {
    return (e) => {
      this.setState({ anchorEl: null });
      if (callback) {
        callback(e);
      }
    };
  }

  @bind
  handleClose() {
    this.setState({ anchorEl: null });
  }

  render() {
    const { className, element, iconButtonElement, children } = this.props;
    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        {element && React.cloneElement(element, { onClick: this.handleClick })}
        {iconButtonElement && (
          <IconButton
            className={className}
            aria-owns={anchorEl ? 'icon-menu' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            {iconButtonElement}
          </IconButton>
        )}

        <Menu
          id="icon-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          {React.Children.toArray(children(this.generateCloseWrapper, this.handleClose))}
        </Menu>
      </React.Fragment>
    );
  }
}

export default IconMenu;
